<template>
 <b-card border-variant='warning' class='mt-2 mb-2'>
      <h5 slot="header">
         <ftr-focus></ftr-focus>
      </h5> 
    <b-row>
      <b-col md='2' offset='5' class="mt-2">   
        <b-btn-group size="sm" variant="danger-outline">
          <b-btn  variant="outline-secondary" @click="intervalChange('1m')"> 1m </b-btn>
          <b-btn  variant="outline-secondary" @click="intervalChange('1h')"> 1h </b-btn>
          <b-btn  variant="outline-secondary" @click="intervalChange('1d')"> 1d </b-btn>
          <b-btn  variant="outline-secondary" @click="intervalChange('1w')"> 1w </b-btn>
          <b-btn  variant="outline-secondary" @click="intervalChange('1y')"> 1y </b-btn>   
        </b-btn-group>  
      </b-col>
    </b-row>  
    <b-row>
      <b-col>
        <canvas :id='title' width="100vw" height="20vh"></canvas>
      </b-col>  
    </b-row>
   
  </b-card>
</template>

<script>
import Chart from 'chart.js'
import axios from 'axios'
// import ChartF  from '@/helpers/chart-financial.js'

export default {
  watch: {
    symbolFocus: function () {
      this.updateChart()
    }
  },
  data () {
    return {
      update: false,
      myChart: null,
      candles: [],
      candlesAmount: 101,
      candledate: [],
      open: [],
      closes: [],
      high: [],
      low: [],
      startDate: new Date(),
      interval: '1d',
      intervalOptions: [
        {value: '1M', text: 'Month'},
        {value: '1w', text: 'Week'},
        {value: '3d', text: '3 Day'},
        {value: '1d', text: 'Day'},
        {value: '12h', text: '12 Hours'},
        {value: '4h', text: '4 Hours'},
        {value: '1h', text: 'Hour'},
        {value: '30m', text: '30 Minutes'},
        {value: '15m', text: '15 Minutes'},
        {value: '5m', text: '5 Minutes'},
        {value: '1m', text: '1 Minute'}
      ],
      // start of chart data
      ChartData: {
        type: 'line',
        data: {
          // this is the bottom labals
          lineAtIndex: 2,
          labels: [],
          // this is the first dataset
          datasets: [
            { // one line graph
              label: 'High',
              data: [],
              borderColor: [ 'rgba(0,200,0,0.5)' ],
              backgroundColor: [ 'rgba(255,193,7,0.1)' ],
              fill: 1,
              pointHoverRadius: 5,
              pointRadius: 0
            },
      //      2nd data set
            { // another line graph
              label: 'Low',
              data: [],
              borderColor: [ 'rgba(255,0,0,0.5)' ],
              backgroundColor: [ 'rgba(73,73,73,0.2)' ],
              fill: 'origin',
              type: 'line',
              pointHoverRadius: 5,
              pointRadius: 0
            }
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          tooltips: {
            caretPadding: 4,
            titleFontSize: 20,
            bodyFontSize: 15,
            bodyFont: 'Lato',
            backgroundColor: 'rgba(73,73,73,0.5)',
            displayColors: false,
            mode: 'x',
            intersect: false
          },
          hover: {
            mode: 'index',
            intersect: false
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              display: false,
              gridLines: {display: false},
              ticks: {
                beginAtZero: false,
                padding: 25
              }
            }],
            xAxes: [{
              display: true,
              gridLines: {display: false},
              type: 'time',
              time: {
                unit: 'week',
                tooltipFormat: 'MMM D , YYYY',
                displayFormats: {
                  week: 'MMM D'
                }
              }
            }]
          },
          layout: {
            padding: {
              left: -50,
              right: 0,
              top: 0,
              bottom: 0
            }
          }
        }
      }
      // end of chart data
    }
  },
  computed: {
    symbolFocus () {
      return this.$store.getters.symbolFocus
    },
    chartUpdate () {
      return this.$store.getters.chartUpdate
    },
    title () { return 'charty' }
  },
  methods: {
  /* eslint-disable no-unused-vars */
    createChart (chartId, chartData) {
      const ctx = document.getElementById(chartId)
      this.myChart = new Chart(ctx, this.ChartData)
      console.log(this.myChart)
    },
    intervalChange (interval) {
      this.interval = interval
      console.log('changed interval:', this.interval)
      this.updateChart()
    },
    updateChart () {
      console.log('Update Chart:', this.interval, this.symbolFocus.pair, this.startDate)
      this.update = true
      this.getCandles()
    },
    dateChange () {
      console.log('changed date:', this.startDate)
    },
    getCandles () {
      console.log('getting Candles')
      var url = 'https://us-central1-ftrworkscom.cloudfunctions.net/candles'
      var more = {
        symbol: this.symbolFocus.pair,
        interval: this.interval,
        limit: this.candlesAmount
      }
      console.log(more)
      axios.get(url, {params: more})
      .then(response => {
        this.candles = response.data
        this.parseCandles()
        if (this.update) {
          this.myChart.update(this.ChartData)
          console.log('updating')
          console.log(this.myChart)
        } else {
          this.createChart(this.title, this.ChartData)
          console.log('First Time')
        }
        return this.candles
      })
      .catch(error => {
        console.log(error)
        return error
      })
    },
    parseCandles () {
      console.log('Candles:', this.candles)
      for (let i = 0; i < this.candles.length; i++) {
        this.high[i] = parseFloat(this.candles[i].high)
        this.low[i] = parseFloat(this.candles[i].low)
        this.closes[i] = parseFloat(this.candles[i].open)
        this.open[i] = parseFloat(this.candles[i].close)
        let tempdate = new Date(this.candles[i].closeTime)
        this.candledate[i] = tempdate.toLocaleDateString()
      }
      this.ChartData.data.labels = this.candledate
      this.ChartData.data.datasets[0].data = this.high
      this.ChartData.data.datasets[1].data = this.low
      console.log('Closes:', this.closes)
      console.log('Candle Dates:', this.candledate)
    }

  },
  /* eslint-enable no-unused-vars */
  mounted () {
    console.log('Home - (mounted)')
    this.getCandles()
  }
}

</script>

<style scoped>

.card-body{
  padding: 0px;
  border: 3px;
}
.card-header{
  padding-bottom: 0rem;
}
</style>


// WEBPACK FOOTER //
// src/components/btr-chart.vue